import React from "react"
import {LazyLoadImage} from "react-lazy-load-image-component";
import LocationPicker from "../../../components/newComps/LocationPicker";

const Step1 = (props) => {
    let {boxIndex, _placeOrderCallback} = props;
    return (
        <div>
            {boxIndex == 0 ?
                <div className={'row'}>
                    <div className={'col-md-12'}>
                        <div className={'locationPicker'}>
                            <div className="laundryPlaceOrder intro-info">
                                <div className={'logoBox'}>
                                    <LazyLoadImage src="/assets/img/1StopWash-logo.svg"
                                                   className="img-fluid"/>
                                </div>
                                <div id="custom-search-input">
                                    <LocationPicker
                                        _placeOrderCallback={_placeOrderCallback} {...props}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> : null}
        </div>
    )
}
export default Step1
